<template>
  <div class="testimonials-area bg-1d2b53 ptb-100">
    <div class="container">
      <div class="section-title white-color">
        <span class="sub-title">Depoimentos</span>
        <h2>O que nossos clientes dizem sobre nossos serviços</h2>
      </div>
      <div class="testimonials-slides">
        <carousel
            :autoplay="5000"
            :wrap-around="true"
        >
          <Slide v-for="slide in carouselItems" :key="slide.id">
            <div class="single-testimonials-item">
              <p>{{slide.desc}}</p>
              <div class="client-info d-flex align-items-center justify-content-center">
                <img :src="slide.image" alt="user">
                <div class="info">
                  <h3>{{slide.name}}</h3>
                  <span>{{slide.position}}</span>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination />
          </template>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide, Pagination  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
  name: 'Testimonials',
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: 'center',
    },
    carouselItems: [
      {
        id: 1,
        desc: 'Precisávamos de um sistema para gerenciar nossos clientes e a equipe entregou exatamente o que queríamos. O sistema é intuitivo, rápido e tem todas as funcionalidades que precisamos. O suporte pós-entrega também é excelente.',
        image: require('../../assets/images/user/user1.jpg'),
        name: 'Carolina Silva',
        position: 'Diretora Comercial - AutoCenter Silva',
      },
      {
        id: 2,
        desc: 'Nossa loja virtual desenvolvida por eles superou todas as expectativas! As vendas online aumentaram 300% no primeiro semestre. O painel administrativo é muito fácil de usar e a integração com o estoque funciona perfeitamente.',
        image: require('../../assets/images/user/user2.jpg'),
        name: 'Roberto Santos',
        position: 'CEO - Moda & Estilo',
      },
      {
        id: 3,
        desc: 'Desenvolveram um aplicativo móvel incrível para nossos clientes. A interface é moderna, funciona perfeitamente tanto no Android quanto no iOS. Nossos usuários elogiam sempre a facilidade de uso do app.',
        image: require('../../assets/images/user/user3.jpg'),
        name: 'Ana Cristina',
        position: 'Gerente de TI - FitClub Academia',
      },
      {
        id: 4,
        desc: 'Precisávamos integrar nosso sistema antigo com novas ferramentas e eles fizeram um trabalho excepcional. Tudo funciona em harmonia agora. O projeto foi entregue no prazo e dentro do orçamento.',
        image: require('../../assets/images/user/user4.jpg'),
        name: 'Pedro Oliveira',
        position: 'Diretor de Operações - LogiTrans',
      },
      {
        id: 5,
        desc: 'Contratamos para automatizar nossos processos internos e o resultado foi fantástico. Reduzimos o tempo de trabalho manual em 70% e aumentamos nossa produtividade significativamente. Recomendo muito!',
        image: require('../../assets/images/user/user5.jpg'),
        name: 'Mariana Costa',
        position: 'Sócia-Fundadora - Consultoria Empresarial MC',
      },
    ],
  }),
})
</script>